const blogSelectors = {

};

class TemplateBlogArticleJS {
    constructor() {
        // Custom code for blog/article page goes here
        document.querySelectorAll('[data-second-level] li').forEach(ele=>{
            ele.addEventListener('click',(event)=>{
                event.preventDefault();
                event.stopPropagation();
                if (!ele.classList.contains('open')) {
                    if (ele.querySelector('[data-third-level]') && !ele.closest('[data-third-level]')) {
                        ele.closest('[data-second-level]')?.classList.toggle('open');
                        ele.querySelector('[data-third-level]')?.classList.toggle('d-none');
                    }
                    if(!ele.querySelector('[data-third-level]') && !ele.closest('[data-third-level]')) {
                        document.querySelector('[data-third-level]:not(.d-none)')?.classList.add('d-none');
                        document.querySelector('[data-second-level].open')?.classList.remove('open');   
                    }
    
                    if(ele.closest('[data-third-level]')){
                        document.querySelectorAll('[data-third-level] li.open').forEach((e)=>{
                            e.classList.remove('open')
                        })
                        ele.classList.add('open');
                    }else{
                        document.querySelectorAll('[data-second-level] li.open').forEach((e)=>{
                            e.classList.remove('open')
                        })
                        ele.classList.add('open');
                    }
                }
            })
        })

        document.querySelectorAll('[data-article-tab]').forEach(ele => ele.addEventListener('click',this._fetchBlogs.bind(this)))
    }

    async _fetchBlogs(event){
        event.preventDefault();
       
        if(!event.target?.closest('li')?.classList.contains('open')){
            let href = event.target.closest('a').getAttribute('data-href');
            document.querySelector('[data-all-articles]')?.classList.add('opacity-0-5');
            if (href != "") {
                if (window.globalVariables.template == 'blog') {
                    let response = await fetch(href);
                    if (response.ok) {
                        let data = await response.text();
                        var parser = new DOMParser();
                        var doc = parser.parseFromString(data, 'text/html');
                        document.querySelector('[data-all-articles]')?.classList.remove('opacity-0-5');
                        document.querySelector('[data-all-articles]').innerHTML = doc.querySelector('[data-all-articles]').innerHTML;
                        document.querySelector('.pagination').innerHTML = doc.querySelector('.pagination').innerHTML;
                    }
                    window.history.pushState('', '', `${href}`);
                }else{
                    window.location.href=href
                }
            }
        }

    }
}

typeof TemplateBlogArticleJS !== 'undefined' && new TemplateBlogArticleJS();
